<template>
  <section>
    <!--工具条-->
    <div class="filtrateBox">
      <el-input
        size="mini"
        @blur="inputChange"
        style="width: 200px"
        v-model="pictureBookName"
        placeholder="请输入绘本名称"
      />
      <el-select
        size="mini"
        v-model="categoryId"
        @change="inputChange"
        placeholder="请选择分类"
      >
        <el-option
          v-for="item in categoryList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>
      <el-select
        size="mini"
        v-model="StoryCategoryId"
        @change="inputChange"
        placeholder="请选择分类"
      >
        <el-option
          v-for="item in StoryCategoryList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>
      <el-button size="mini" @click="addFn" type="success">新增</el-button>
      <el-button
        size="mini"
        :disabled="sels.length == 0 ? true : false"
        @click="AdminOpenCloseStory(true)"
        type="primary"
        >批量上架</el-button
      >
      <el-button
        size="mini"
        :disabled="sels.length == 0 ? true : false"
        @click="AdminOpenCloseStory(false)"
        type="danger"
        >批量下架</el-button
      >
    </div>

    <!--列表-->
    <el-table
      :data="cartoonmain"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      height="500"
      border
      style="width: 100%"
    >
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column type="index" align="center"></el-table-column>
      <el-table-column
        prop="TypeName"
        label="分类名"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Title"
        align="center"
        label="标题"
        sortable
      ></el-table-column>
      <el-table-column
        prop="SuitableAge"
        label="适应年龄段"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="Author"
        align="center"
        label="作者"
        sortable
      ></el-table-column>

      <el-table-column label="图片" align="center" sortable
        ><template slot-scope="scope"
          ><img
            :src="scope.row.CoverImgUrl"
            style="width: 120px; height: 100px" /></template
      ></el-table-column>

      <el-table-column
        prop="CreateTime"
        label="创建时间"
        align="center"
        :formatter="formatCreateTime"
        width
        sortable
      ></el-table-column>
      <el-table-column label="状态" align="center" width sortable
        ><template slot-scope="scope">
          <el-tag v-if="scope.row.IsPub" type="success">已上架</el-tag>
          <el-tag type="info" v-else>已下架</el-tag>
        </template></el-table-column
      >
      <el-table-column label="操作" width="300" align="center"
        ><template slot-scope="scope">
          <el-button type="success" size="mini" @click="updateFn(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="AdminGeStoryItemBytPage(scope.row.Id)"
            >查看绘本子页</el-button
          >
          <el-button
            type="primary"
            size="mini"
            style="background: #5474e6; border: 1px solid #5474e6"
            @click="AdminGetStoryAfterQuestion(scope.row)"
            >问题详情</el-button
          >
          <!-- <el-button type="danger" size="mini" @click="delectFn(scope.row.Id)"
            >删除</el-button
          > -->
        </template></el-table-column
      >
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        layout="prev, pager, next,sizes"
        :page-sizes="[10, 50, 100, 200, 300, 400]"
        @current-change="handleCurrentChange"
        :page-size="PageSize"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!--子页列表-->
    <el-dialog
      title="子页列表"
      :visible.sync="childPageVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-button @click="AdminAddUpdateStoryItem" size="mini" type="primary"
        >新加页面</el-button
      >
      <el-dialog
        width="30%"
        :title="updateBookChildId ? '修改子页' : '新增子页'"
        :visible.sync="addChildPageVisibel"
        append-to-body
      >
        <el-form label-width="100px">
          <el-form-item label="故事配图">
            <el-upload
              class="avatar-uploader"
              action="/api/Img/UploadImage/"
              :headers="token"
              :show-file-list="false"
              width="380"
              :on-success="handleAvatarSuccessChildImage"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="addFormChild.imgUrl"
                :src="addFormChild.imgUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="故事匹配音频">
            <el-upload
              class="avatar-uploader"
              action="/api/Img/UploadFile"
              :headers="token"
              :show-file-list="false"
              width="380"
              :on-success="handleAvatarSuccessAudio"
              :before-upload="beforeAudioUpload"
              :on-progress="audioProgress"
            >
              <audio
                v-if="addFormChild.aduioUrl"
                :src="addFormChild.aduioUrl"
                controls
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-progress
              :percentage="audioPlan"
              style="width: 300px"
              v-if="audioPlan"
            ></el-progress>
          </el-form-item>
          <el-form-item label="故事文字描述">
            <el-input
              :autosize="{ minRows: 4 }"
              v-model="addFormChild.text"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number
              :min="0"
              v-model="addFormChild.orderSort"
            ></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addChildPageVisibel = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click.native="AdminAddUpdateStoryItemOffirm"
            >提交</el-button
          >
        </div>
      </el-dialog>
      <el-table :data="pageChildList" style="width: 100%">
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CategoryName"
          label="分类名称"
          sortable
        ></el-table-column>
        <el-table-column
          prop="TypeName"
          label="类型"
          sortable
        ></el-table-column>
        <el-table-column
          prop="MainName"
          label="绘本名称"
          sortable
        ></el-table-column>
        <el-table-column prop="imgUrl" label="故事配图">
          <template slot-scope="scope"
            ><img :src="scope.row.ImgUrl" style="width: 120px; height: 100px"
          /></template>
        </el-table-column>
        <el-table-column prop="Text" label="故事文字描述"></el-table-column>
        <el-table-column prop="AduioUrl" width="330" label="故事匹配音频">
          <template slot-scope="scope"
            ><audio
              controls
              style="width: 300px"
              width="100"
              :src="scope.row.AduioUrl"
            ></audio
          ></template>
        </el-table-column>
        <el-table-column label="操作"
          ><template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="updateChildFn(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="AdminDeleteStoryItem(scope.row.Id)"
              >删除</el-button
            >
          </template></el-table-column
        >
      </el-table>
    </el-dialog>

    <!--新增绘本界面-->
    <el-dialog
      :title="updateBookId ? '修改' : '新增'"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="分类" prop="CId">
          <el-select
            v-model="addForm.categoryId"
            @change="changeselect"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in categoryListAdd"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程类型" prop="CId">
          <el-select
            v-model="addForm.typeId"
            @change="changeselect"
            placeholder="请选择课程类型"
          >
            <el-option
              v-for="item in StoryCategoryListAdd"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="title">
          <el-input v-model="addForm.author" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="title">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="addForm.summary"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="封面图片">
          <el-upload
            class="avatar-uploader"
            action="/api/Img/UploadImage/"
            :headers="token"
            :show-file-list="false"
            width="380"
            :on-success="handleAvatarSuccessCoverImgUrl"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="addForm.coverImgUrl"
              :src="addForm.coverImgUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="封面小图">
          <el-upload
            class="avatar-uploader"
            action="/api/Img/UploadImage/"
            :headers="token"
            :show-file-list="false"
            width="380"
            :on-success="handleAvatarSuccessThuImgUrl"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="addForm.thuImgUrl"
              :src="addForm.thuImgUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否上架" prop="IsPub">
          <el-radio-group v-model="addForm.isPub">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="适用年龄段" prop="suitableAge">
          <el-input
            v-model="addForm.suitableAge"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="OrderSort">
          <el-input-number
            :min="0"
            v-model="addForm.orderSort"
            auto-complete="off"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 题目列表 -->
    <el-dialog
      title="题目列表"
      :visible.sync="topicListVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <el-button size="mini" type="primary" @click="addTopic"
        >新增题目</el-button
      >
      <el-table :data="topicList" empty-text="暂无题目" style="width: 100%">
        <el-table-column prop="Ex_Questions" label="问题">
          <template slot-scope="scope">
            <el-image
              style="width: 400px; height: 100px"
              fit="contain"
              :src="scope.row.Ex_Questions"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="Ex_QuestionsMusic" label="音频">
          <template slot-scope="scope">
            <audio :src="scope.row.Ex_QuestionsMusic" controls></audio>
          </template>
        </el-table-column>
        <el-table-column prop="ex_Questions" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="success"
              @click="updateTopic(scope.row)"
              size="mini"
              >编辑</el-button
            >
            <el-button type="danger" @click="DeleteTopic(scope.row)" size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        width="40%"
        title="问题详情"
        :visible.sync="topicInnerVisible"
        append-to-body
      >
        <el-form label-width="100px">
          <el-form-item label="问题">
            <el-upload
              class="avatar-uploader"
              action="/api/Img/UploadImage/"
              :headers="token"
              :show-file-list="false"
              width="380"
              :on-success="handleAvatarSuccessQuestions"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="topicInfo.ex_Questions"
                :src="topicInfo.ex_Questions"
                class="avatar"
                style="object-fit: contain; height: auto"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="问题音乐">
            <upload-self
              action="/api/Img/UploadFile/"
              :width="320"
              :height="40"
              fileType="audio"
              :flag="index"
              v-model="topicInfo.ex_QuestionsMusic"
            ></upload-self>
          </el-form-item>
        </el-form>
        <el-button size="mini" type="primary" @click="addOption"
          >新增选项</el-button
        >
        <div class="ex_AnswerList">
          <div class="AnswerListFlex AnswerListFlexTitle">
            <div>选项图片</div>
            <div>排序值</div>
            <div>是否是正确答案</div>
            <div>操作</div>
          </div>
          <div
            v-for="(row, index) in topicInfo.ex_Answer"
            :key="index"
            class="AnswerListFlex"
          >
            <div>
              <upload-self
                action="/api/Img/UploadImage/"
                :width="200"
                :height="200"
                :flag="index"
                v-model="row.bg"
              ></upload-self>
            </div>
            <div>
              <el-input-number v-model="row.Sort"></el-input-number>
            </div>
            <div>
              <el-button
                type="success"
                @click="setGhtAnswers(index)"
                v-if="!row.IsRight"
                size="mini"
              >
                设为正确答案
              </el-button>
              <el-button type="info" disabled v-else size="mini">
                正确答案
              </el-button>
            </div>
            <div>
              <el-button type="danger" @click="deleteOPtion(index)" size="mini">
                删除
              </el-button>
            </div>
          </div>
          <div
            v-if="topicInfo.ex_Answer.length == 0"
            style="text-align: center; padding-top: 10px"
          >
            暂无选项
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="success" @click.native="AdminAddUpdateStoryQuestio"
            >确认提交</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
// import { quillEditor } from "vue-quill-editor"; //调用编辑器
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  AdminGetStoryByPage,
  FrontGetStoryTypeSelet,
  FrontGetStoryCategorySelet,
  AdminAddUpdateStory,
  AdminGetStoryOneInfo,
  AdminOpenCloseStory,
  AdminGeStoryItemBytPage,
  AdminAddUpdateStoryItem,
  AdminDeleteStoryItem,
  AdminAddUpdateStoryQuestion,
  AdminGetStoryAfterQuestion,
  AdminDeleteStoryQuestion,
} from "../../api/api";
import uploadSelf from "@/components/upload_self.vue";
import jsPDF from "jspdf";
// import { getButtonList } from "../../promissionRouter";
// import Toolbar from "../../components/Toolbar";

export default {
  components: {
    // Toolbar, //使用编辑器
    // quillEditor,
    uploadSelf,
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  data() {
    return {
      StoryCategoryList: [],
      StoryCategoryListAdd: [],
      StoryCategoryId: "",
      categoryList: [],
      categoryListAdd: [],
      categoryId: "",
      pictureBookName: "", // 绘本名称
      updateBookId: 0, //需要更新的绘本id
      updateBookChildId: 0, //需要更新的绘本子页id
      checked: [],
      childPageVisible: false,
      addChildPageVisibel: false,
      pageChildList: [], //子页列表
      audioPlan: 0, //音频的上传进度
      topicListVisible: false,
      topicInnerVisible: false,
      topicId: "", //问题id
      topicInfo: {
        mainId: 0,
        ex_Questions: "",
        ex_QuestionsMusic: "",
        ex_Answer: [],
      },
      isXhr: false,
      topicList: [],
      //新增界面数据
      addForm: {
        categoryId: "",
        typeId: "",
        coverImgUrl: "",
        thuImgUrl: "",
        title: "",
        suitableAge: "",
        summary: "",
        author: "",
        isPub: true,
        orderSort: 0,
      },
      // 新增子页id
      addFormChild: {
        mainId: 0,
        imgUrl: "",
        text: "",
        aduioUrl: "",
        orderSort: 0,
      },
      //编辑单个
      token: {
        Authorization: "Bearer ",
      },
      currentRow: null,
      cartoonmain: [], //绘本列表
      total: 0,
      page: 1,
      PageSize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
    };
  },
  methods: {
    DeleteTopic(item) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await AdminDeleteStoryQuestion({
            id: item.Id,
          });
          if (xhr.data.success) {
            this.$message.success("删除成功");
            this.AdminGetStoryAfterQuestion({
              Id: this.topicInfo.mainId,
            });
          } else {
            this.$message.success(xhr.data.msg);
          }
        })
        .catch(() => {});
    },
    addTopic() {
      this.topicId = "";
      this.topicInnerVisible = true;
      this.topicInfo.ex_Questions = "";
      this.topicInfo.ex_Answer = [];
      this.topicInfo.ex_QuestionsMusic = "";
    },
    async AdminAddUpdateStoryQuestio() {
      if (this.topicInfo.ex_Answer.length == 0) {
        this.$message.error("请添加选项");
        return;
      }
      for (let index = 0; index < this.topicInfo.ex_Answer.length; index++) {
        const element = this.topicInfo.ex_Answer[index];
        if (!element.bg) {
          this.$message.error("请给选项上传图片");
          return;
        }
      }
      let isRight = this.topicInfo.ex_Answer.find((item) => {
        return item.IsRight;
      });
      if (!isRight) {
        this.$message.error("请设置一项正确答案");
        return;
      }
      if (!this.topicInfo.ex_Questions) {
        this.$message.error("请上传问题所对应的图片");
        return;
      }
      if (!this.topicInfo.ex_QuestionsMusic) {
        this.$message.error("请上传问题所对应的音频");
        return;
      }
      let prams = JSON.parse(JSON.stringify(this.topicInfo));
      prams.ex_Answer = JSON.stringify(prams.ex_Answer);
      if (this.topicId) {
        prams.id = this.topicId;
      }
      if (this.isXhr) {
        return;
      }
      this.isXhr = true;
      let xhr = await AdminAddUpdateStoryQuestion(prams);
      this.isXhr = false;
      if (xhr.data.success) {
        if (this.topicId) {
          this.$message.success("修改成功");
        } else {
          this.$message.success("添加成功");
        }
        this.topicId = "";
        this.topicInnerVisible = false;
        this.topicInfo.ex_Questions = "";
        this.topicInfo.ex_Answer = [];
        this.topicInfo.ex_QuestionsMusic = "";
        this.AdminGetStoryAfterQuestion({
          Id: this.topicInfo.mainId,
        });
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    // 添加问题
    addOption() {
      if (this.topicInfo.ex_Answer.length >= 4) {
        this.$message.warning("最多四个选项");
        return;
      }
      this.topicInfo.ex_Answer.push({
        IsRight: false,
        Sort: this.topicInfo.ex_Answer.length + 1,
        bg: "",
        value: "",
      });
    },
    // 删除问题
    deleteOPtion(index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.topicInfo.ex_Answer.splice(index, 1);
        })
        .catch(() => {});
    },
    // 设为正确答案
    setGhtAnswers(index) {
      this.topicInfo.ex_Answer.forEach((item) => {
        item.IsRight = false;
      });
      this.topicInfo.ex_Answer[index].IsRight = true;
    },
    updateTopic(item) {
      this.topicId = item.Id;
      this.topicInfo.ex_Questions = item.Ex_Questions;
      this.topicInfo.ex_QuestionsMusic = item.Ex_QuestionsMusic;
      this.topicInfo.ex_Answer = item.Ex_Answer;
      this.topicInnerVisible = true;
    },
    // 获取故事问题
    async AdminGetStoryAfterQuestion(item) {
      this.topicLis = [];
      this.topicListVisible = true;
      this.topicInfo.mainId = item.Id;
      let xhr = await AdminGetStoryAfterQuestion({
        id: item.Id,
      });
      if (xhr.data.success) {
        this.topicList = xhr.data.response;
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
    updateChildFn(item) {
      this.addFormChild.mainId = this.updateBookId;
      this.addFormChild.imgUrl = item.ImgUrl;
      this.addFormChild.text = item.Text;
      this.addFormChild.aduioUrl = item.AduioUrl;
      this.addFormChild.orderSort = item.OrderSort;
      this.updateBookChildId = item.Id;
      this.addChildPageVisibel = true;
    },
    // 删除子页
    AdminDeleteStoryItem(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await AdminDeleteStoryItem({
            ids: [id],
          });
          if (xhr.data.success) {
            this.$message.success("删除成功");
            this.AdminGeStoryItemBytPage();
          } else {
            this.$message.success(xhr.data.msg);
          }
        })
        .catch(() => {});
    },
    // 添加子页
    AdminAddUpdateStoryItem() {
      this.updateBookChildId = "";
      this.addChildPageVisibel = true;
    },
    async AdminAddUpdateStoryItemOffirm() {
      this.addFormChild.mainId = this.updateBookId;
      if (!this.addFormChild.imgUrl) {
        this.$message.warning("请上传故事配图");
        return;
      }
      if (!this.addFormChild.text) {
        this.$message.warning("请上传文字描述");
        return;
      }
      if (!this.addFormChild.aduioUrl) {
        this.$message.warning("请上传故事匹配音频");
        return;
      }
      if (this.updateBookChildId) {
        this.addFormChild.id = this.updateBookChildId;
      }
      let xhr = await AdminAddUpdateStoryItem(this.addFormChild);
      if (xhr.data.success) {
        this.addFormChild.id = "";
        this.addChildPageVisibel = false;
        this.AdminGeStoryItemBytPage(this.updateBookId);
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async AdminGeStoryItemBytPage(id) {
      this.pageChildList = [];
      this.updateBookId = id;
      this.childPageVisible = true;
      let xhr = await AdminGeStoryItemBytPage({
        Id: id,
        Name: "",
      });

      if (xhr.data.success) {
        this.pageChildList = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    addFn() {
      this.updateBookId = 0;
      this.addFormVisible = true;
    },

    handleAvatarSuccessThuImgUrl(res) {
      if (res.success) {
        this.addForm.thuImgUrl = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },
    handleAvatarSuccessCoverImgUrl(res) {
      if (res.success) {
        this.addForm.coverImgUrl = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },
    audioProgress(e) {
      this.audioPlan = Math.ceil((e.percent / e.total) * 100);
      if (this.audioPlan >= 100) {
        setTimeout(() => {
          this.audioPlan = 0;
        }, 200);
      }
    },
    handleAvatarSuccessQuestionsAudio(res) {
      if (res.success) {
        this.topicInfo.ex_QuestionsMusic = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },
    handleAvatarSuccessAudio(res) {
      if (res.success) {
        this.addFormChild.aduioUrl = res.response;
        this.audioPlan = 100;
        setTimeout(() => {
          this.audioPlan = 0;
        }, 200);
      } else {
        this.$message.warning("上传失败");
      }
    },
    handleAvatarSuccessQuestions(res) {
      if (res.success) {
        this.topicInfo.ex_Questions = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },
    handleAvatarSuccessChildImage(res) {
      if (res.success) {
        this.addFormChild.imgUrl = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },

    beforeAudioUpload(file) {
      let typeArr = file.type.split("/");
      if (typeArr[0] == "audio") {
        return true;
      } else {
        this.$message.warning("请上传音频文件");
        return false;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG或png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },

    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleSizeChange(value) {
      this.page = 1;
      this.PageSize = value;
      this.getMainlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMainlist();
    },
    inputChange() {
      this.page = 1;
      this.getMainlist();
    },
    //获取用户列表
    async getMainlist() {
      let xhr = await AdminGetStoryByPage({
        Name: this.pictureBookName ? this.pictureBookName : undefined,
        TypeId: this.StoryCategoryId ? this.StoryCategoryId : undefined,
        CategoryId: this.categoryId ? this.categoryId : undefined,
        PageIndex: this.page,
        PageSize: this.PageSize,
      });
      if (xhr.data.success) {
        this.total = xhr.data.response.dataCount;
        this.cartoonmain = xhr.data.response.data;
        this.listLoading = false;
      } else {
        this.cartoonmain = [];
        this.listLoading = false;
      }
    },

    // 批量上下架
    async AdminOpenCloseStory(value) {
      let ids = [];
      this.sels.forEach((item) => {
        ids.push(item.Id);
      });
      let xhr = await AdminOpenCloseStory({
        ids: ids,
        isPub: value,
      });
      if (xhr.data.success) {
        this.$message.success("操作成功");
        this.getMainlist();
      } else {
        this.$message.error("操作失败");
      }
    },

    // 修改
    async updateFn(item) {
      this.addFormVisible = true;
      let xhr = await AdminGetStoryOneInfo({
        Id: item.Id,
      });
      this.updateBookId = item.Id;
      if (xhr.data.success) {
        this.addForm.categoryId = xhr.data.response.CategoryId;
        this.addForm.typeId = xhr.data.response.TypeId;
        this.addForm.coverImgUrl = xhr.data.response.CoverImgUrl;
        this.addForm.thuImgUrl = xhr.data.response.ThuImgUrl;
        this.addForm.title = xhr.data.response.Title;
        this.addForm.suitableAge = xhr.data.response.SuitableAge;
        this.addForm.summary = xhr.data.response.Summary;
        this.addForm.author = xhr.data.response.Author;
        this.addForm.isPub = xhr.data.response.IsPub;
        this.addForm.orderSort = xhr.data.response.OrderSort;
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
    //新增
    async addSubmit() {
      if (!this.addForm.coverImgUrl) {
        this.$message.warning("请上传封面图片");
        return;
      }
      if (!this.addForm.thuImgUrl) {
        this.$message.warning("请上传封面小图");
        return;
      }
      if (!this.addForm.title) {
        this.$message.warning("请填写标题");
        return;
      }
      if (!this.addForm.suitableAge) {
        this.$message.warning("请填写适龄范围");
        return;
      }
      if (!this.addForm.author) {
        this.$message.warning("请填写作者");
        return;
      }
      if (!this.addForm.summary) {
        this.$message.warning("请填写简介");
        return;
      }
      if (this.updateBookId) {
        this.addForm.id = this.updateBookId;
      }
      let xhr = await AdminAddUpdateStory(this.addForm);

      if (xhr.data.success) {
        this.addFormVisible = false;
        this.addForm.coverImgUrl = "";
        this.addForm.thuImgUrl = "";
        this.addForm.title = "";
        this.addForm.suitableAge = "";
        this.addForm.author = "";
        this.addForm.summary = "";
        this.updateBookId = "";
        this.addForm.id = undefined;
        this.$message.success("添加成功");
        this.getMainlist();
      } else {
        this.$message.error(xhr.data.msg);
      }
    },

    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    changeselect(value) {},
    // 获取类型
    async FrontGetStoryCategorySelet() {
      let xhr = await FrontGetStoryCategorySelet();
      if (xhr.data.success) {
        this.StoryCategoryList = [
          { Id: 0, Name: "全部课程类型" },
          ...xhr.data.response,
        ];
        this.StoryCategoryListAdd = xhr.data.response;
      } else {
        this.StoryCategoryList = [{ Id: 0, Name: "全部课程类型" }];
      }
    },
    // 获取分类
    async getTypes() {
      let xhr = await FrontGetStoryTypeSelet();

      if (xhr.data.success) {
        this.categoryList = [{ Id: 0, Name: "全部分类" }, ...xhr.data.response];
        this.categoryListAdd = xhr.data.response;
      } else {
        this.categoryList = [{ Id: 0, Name: "全部分类" }];
      }
    },
  },
  mounted() {
    this.getMainlist();
    this.getTypes();
    this.FrontGetStoryCategorySelet();
  },
};
</script>

<style scoped lang="less">
.AnswerListFlexTitle {
  font-weight: bold;
}
.AnswerListFlex {
  display: flex;
  align-items: center;
  padding: 10px 0;
  div {
    text-align: center;
  }
}
.AnswerListFlex > div:nth-child(1) {
  width: 240px;
}
.AnswerListFlex > div:nth-child(2) {
  width: 240px;
}
.AnswerListFlex > div:nth-child(3) {
  width: 100px;
}
.AnswerListFlex > div:nth-child(4) {
  flex: 1;
}
.filtrateBox {
  display: flex;
  padding-bottom: 20px;
  margin-bottom: 10px;
  div {
    margin-right: 10px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px solid #c0c4cc;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
  object-fit: cover;
}
.avatars {
  width: 95px;
  height: 108px;
  display: block;
}
.avatarlist {
  width: 225px;
  height: 241.5px;
  display: block;
}
.avatar-uploader-iconss {
  padding: 10px 0px;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  line-height: 30px;
  /* height: 120px; */
  text-align: center;
}
</style>
